//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React, { useEffect } from 'react';
import styled from 'styled-components';

import { TitleText } from '@components/atoms/text/Text';
import UploadImageSource from '@images/upload.svg';

const DROP_FILES_LABEL = 'Drop files anywhere to upload';

export interface DroppableImageProps {
  isActive: boolean;
  onDragEnter: () => void;
}

export const DroppableImage = ({
  isActive,
  onDragEnter,
}: DroppableImageProps) => (
  <Draggable onDragEnter={onDragEnter}>
    {isActive && (
      <Content>
        <Image alt={DROP_FILES_LABEL} src={UploadImageSource} />
        <Text>{DROP_FILES_LABEL}</Text>
      </Content>
    )}
  </Draggable>
);

const Draggable = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    flex: 1;
    padding: ${theme.spacings[7]};
  `,
);

const Content = styled.div(
  ({ theme }) => `
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${theme.spacings[4]};
    padding: ${theme.spacings[7]};
  `,
);

const Image = styled.img(
  ({ theme }) => `
    width: ${theme.smallMeasure};
  `,
);

const Text = styled(TitleText)(
  ({ theme }) => `
    color: ${theme.colors.white};
  `,
);
